export default "__VITE_ASSET__Cv3ZDbsv__"